var _ = require('underscore/underscore-min');

/**
 * name: ScriptLoader Module
 * description: A simple way to load scripts with a real asynchronous method
 */
var ScriptLoader = (function(root, doc, undefined){

    'use strict';

    /**
     * Load a Script in a real Asynchronous method
     * @param  {String} - url
     * @param  {String} - id
     * @param  {Function} - callback
     */
    var load = function(url, id, callback) {

        var _js = doc.createElement('script');
            _js.async = true;
            _js.src = url;
            _js.id  = id;

        if(callback){
            if(_js.readyState){  // IE
                _js.onreadystatechange = function(){
                    if (_js.readyState == 'loaded' || _js.readyState == 'complete'){
                        _js.onreadystatechange = null;
                        callback(id);
                    }
                };
            }else {  // others
                _js.onload = function(){
                    callback(id);
                };
            }
        }

        firstTag.parentNode.insertBefore(_js, firstTag);

    };

    /**
     * Add a Script into the wait queue if window isn't loaded
     * If window is loaded, inject the script immediatly
     * @param {String}   - url      : Script URL
     * @param {String}   - id       : Script ID (optional)
     * @param {Function} - callback : Invoked when script is loaded (optional)
     * @param {Boolean}  - now      : Force Script to load right now (optional)
     */
    var add = function(url, id, callback, now) {

        // Avoid duplicate script ids
        if(_.indexOf(scriptIDs, id) !== -1){
            return false;
        }

        // Generate an id for each script
        if(!id){
            id = 'script-' + randomId;
            randomId++;
        }

        // ..and push it into the list
        scriptIDs.push(id);

        // Scripts can be injected right now or after load event (default)
        if(now || windowIsLoad){
            load(url, id, callback);
        }else {

            /**
             * If window isn't loaded,
             * then store current arguments.
             * This will be invoked later when window will be loaded
             */
            var array = [];
            array.push(url);
            array.push(id);
            array.push(callback);

            waitList.push(array);

        }

    };

    /**
     * window on 'load' event handler
     */
    var onLoad = function(){

        windowIsLoad = true;

        // For each element in the queue, load it
        for (var i = 0, l = waitList.length; i<l; i++){
            load.apply(null, waitList[i]);
        }

        // Empty queue
        waitList.length = 0;

    };

    // Private vars
    var filename     = 'script-loader.js',
        firstTag     = doc.getElementsByTagName('script')[0],
        waitList     = [],
        scriptIDs    = [],
        randomId     = 0,
        windowIsLoad = false;

    // Attach a load event on window
    root.addEventListener('load', onLoad);

    // Public methods
    return {
        add: add
    };

})(window, document);

module.exports = ScriptLoader;
